import React, {useState, useEffect} from 'react';
import {DialogTitle, MenuItem} from '@material-ui/core';
import {DialogContent} from '@material-ui/core';
import {Formik} from "formik";
import {TextField, Dialog, FormControlLabel} from "../../styles/config";
import validator from './validator';
import {Radio, FormLabel, FormControl, FormHelperText} from '@material-ui/core';
import CircularIntegration from "../../widgets/CircularIntergration";
import Translate, {sanitizePayload} from "../../utils/utils";
import {createResource, updateResource} from "../../utils/formik";

const Grower = ({handleCreate, resource, initialValues, handleUpdate, onCloseModal, growerParents}) => {

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        setOpen(initialValues.id !== undefined);
    }, [initialValues]);


    const closeModal = () => {
        setOpen(false);
        onCloseModal();
    };

    const isCreatingResource = () => {
        return initialValues.id === undefined;
    };

    return (
        <div>
            <button className="btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary"
                    onClick={() => setOpen(true)}>
                <Translate id={"DIALOG.BUTTON.ADD.TITLE"}/>
            </button>
            <Dialog style={{backgroundColor: 'rgba(43, 32, 43, 0.8)'}} onClose={closeModal}
                    aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={closeModal}>
                    <div className="title__user-wrapper">
                        <div className="title__user-action">
                            <CircularIntegration done={!loading} load={loading}/>
                        </div>
                        <div className="title__user-title">
                            <h3>
                                {isCreatingResource() ? <Translate id={"DIALOG.BUTTON.ADD.TITLE"}/> :
                                    <Translate id={"TABLE.ACTIONS.EDIT"}/>} <Translate
                                id={"TABLE.GROWER"}/>
                            </h3>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <Formik
                        initialValues={initialValues}

                        onSubmit={(payload, methods) => isCreatingResource() ? createResource(sanitizePayload(payload), methods, resource, setLoading, handleCreate) : updateResource(sanitizePayload(payload), methods, resource, setLoading, handleUpdate)}
                        enableReinitialize={!isCreatingResource()}
                    >
                        {({
                              values,
                              status,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                          }) => (
                            <form onSubmit={handleSubmit} className="kt-form">
                                {status && (
                                    <div role="alert" className="alert alert-danger">
                                        <div className="alert-text">{status}</div>
                                    </div>
                                )}

                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id={"DIALOG.FORM.RFH_NUMBER"}/>}
                                    type="text" autoComplete="off"
                                    fullWidth={true}
                                    name="rfh_number"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.rfh_number || ''}
                                    helpertext={touched?.rfh_number && errors?.rfh_number}
                                    error={Boolean(touched?.rfh_number && errors?.rfh_number)}
                                />

                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    type="text" autoComplete="off"
                                    label={<Translate id={"DIALOG.FORM.NAME"}/>}
                                    fullWidth={true}
                                    name="name"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.name || ''}
                                    helpertext={touched?.name && errors?.name}
                                    error={Boolean(touched?.name && errors?.name)}
                                />

                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id={"DIALOG.FORM.EMAIL"}/>}
                                    type="text" autoComplete="off"
                                    fullWidth={true}
                                    name="email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.email || ''}
                                    helpertext={touched?.email && errors?.email}
                                    error={Boolean(touched?.email && errors?.email)}
                                />

                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id={"DIALOG.FORM.EMAIL.SECONDARY"}/>}
                                    type="text" autoComplete="off"
                                    fullWidth={true}
                                    name="secondary_email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.secondary_email || ''}
                                    helpertext={touched?.secondary_email && errors?.secondary_email}
                                    error={Boolean(touched?.secondary_email && errors?.secondary_email)}
                                />
                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id={"DIALOG.FORM.PHONE_NUMBER"}/>}
                                    type="text" autoComplete="off"
                                    fullWidth={true}
                                    name="phone"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.phone || ''}
                                    helpertext={touched?.phone && errors?.phone}
                                    error={Boolean(touched?.phone && errors?.phone)}
                                />

                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id={"DIALOG.FORM.CONTACT_PERSON"}/>}
                                    type="text"
                                    autoComplete="off"
                                    fullWidth={true}
                                    name="contact"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.contact || ''}
                                    helpertext={touched?.contact && errors?.contact}
                                    error={Boolean(touched?.contact && errors?.contact)}
                                />
                                <TextField
                                    select
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id={"DIALOG.FORM.PARENT"}/>}
                                    fullWidth={true}
                                    name="parent_id"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.parent_id ?? initialValues?.parent?.id ?? 'null'}
                                    helpertext={touched?.parent_id && errors?.parent_id}
                                    error={Boolean(touched?.parent_id && errors?.parent_id)}
                                >
                                    <MenuItem key='default' value={'null'}>
                                        {'No Parent'}
                                    </MenuItem>
                                    {growerParents.map(growerParent => (

                                        <MenuItem key={growerParent.id} value={growerParent.id}>
                                            {growerParent.name}
                                        </MenuItem>
                                    ))}

                                </TextField>

                                <FormControl component="fieldset">
                                    <FormLabel><Translate id="TABLE.STATUS"/></FormLabel>
                                    <div>
                                        <FormControlLabel
                                            control={<Radio
                                                checked={values?.active === '1'}
                                                onChange={handleChange}
                                                value="1"
                                                name="active"
                                                inputProps={{'aria-label': 'A'}}
                                            />}
                                            label={<Translate id={"TABLE.STATUS.ACTIVE"}/>}
                                            labelPlacement="end"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    checked={values?.active === '0'}
                                                    onChange={handleChange}
                                                    value="0"
                                                    name="active"
                                                    inputProps={{'aria-label': 'B'}}
                                                />
                                            }
                                            label={<Translate id={"TABLE.STATUS.INACTIVE"}/>}
                                            labelPlacement="end"
                                        />
                                    </div>
                                    {Boolean(errors?.status) &&
                                    <FormHelperText error={Boolean(errors?.status)}>{errors?.status}</FormHelperText>
                                    }
                                </FormControl>

                                <div className="kt-add-user__actions">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting || Object.is(initialValues, values)}
                                        className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}

                                    >
                                        {isCreatingResource() ? <Translate id={"DIALOG.FORM.BUTTON.SAVE"}/> :
                                            <Translate id={"DIALOG.FORM.BUTTON.UPDATE"}/>}
                                    </button>
                                    <i
                                        onClick={closeModal}
                                        className={`btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary`}
                                    >
                                        <Translate id={"DIALOG.FORM.BUTTON.CLOSE"}/>
                                    </i>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Grower;
